import React, { FunctionComponent } from 'react';
import {Collapse} from "reactstrap";

interface IProps {
    selectedOption: string;
    isOpen: boolean;
}

const DataReportWaitingTimeWarningMessage: FunctionComponent<IProps> = ({ selectedOption, isOpen }) => {
    const messages = {
        annual: 'Annual data can take up to 2-3 minutes to display, depending on the number of surveys.',
        monthly: 'Monthly data can take up to 2-3 minutes to display, depending on the number of surveys.',
        quarterly: 'Quarterly data can take up to 2-3 minutes to display, depending on the number of surveys.'
    };
    return (
      <Collapse isOpen={isOpen}>
          <small style={{fontSize: '1rem', color: 'orange'}}>{messages[selectedOption.toLowerCase()]}</small>
      </Collapse>
    );
};

export default DataReportWaitingTimeWarningMessage;